import { Schedule } from '../../types/interfaces';

import Api from './api';
import IScheduleApi from './interfaces/scheduleApi';

class ScheduleApi extends Api<Schedule> implements IScheduleApi {
  constructor(abortController: AbortController) {
    super('schedule/', abortController);
  }
}

export default ScheduleApi;
